import i18n from "i18next"
import { initReactI18next } from "react-i18next"

// Importing translation files
import translationУз from "./assets/locales/уз/уз.json"
import translationUz from "./assets/locales/uz/uz.json"
import translationRu from "./assets/locales/ru/ru.json"
import translationEn from "./assets/locales/en/en.json"

//Creating object with the variables of imported translation files
const resources = {
  en: {
    translation: translationEn,
  },
  uz: {
    translation: translationUz,
  },
  ru: {
    translation: translationRu,
  },
  уз: {
    translation: translationУз,
  },
}

//i18N Initialization

i18n.use(initReactI18next).init({
  resources,
  lng: "uz", //default language
  fallbackLng: "uz",
  detection: {
    order: [
      "querystring",
      "cookie",
      "localStorage",
      "sessionStorage",
      "navigator",
      "htmlTag",
      "path",
      "subdomain",
    ],
    caches: ["localStorage"],
  },
  keySeparator: false,
  supportedLngs: ["uz", "ru", "en", "уз"],
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
